import { PiVideoCamera } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { uiNavigationState } from "@/custolink-state/ui_navigation_state";
import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { AdmSupportVideoCallsApi } from "@/custolink-transpiled_by_server/bc.asset_interaction.api_methods";
import useUiContext from "@/custolink-hooks/useUiContext";

export default function IncomingVideoSupport() {
  const navigate = useNavigate();

  const uic = useUiContext();
  const [uiNavState, setUiNavState] = useAtom(uiNavigationState);
  const [show, setShow] = useState(false);

  const liveSessions = useQuery({
    queryFn: () =>
      AdmSupportVideoCallsApi.getLiveSessions(
        uic.organisationContext.organisationId,
      ),
    queryKey: [
      "AdmSupportVideoCallsApi",
      AdmSupportVideoCallsApi.getLiveSessions.name,
      uic.organisationContext.organisationId,
    ],
    enabled: uiNavState.incomingVideoChatPollNow,
    refetchInterval: 15000,
  });

  useEffect(() => {
    // A customer sitting alone in a room is the thing that needs a person's attention -
    // that is what the old pending-call list meant, before there was no accept handshake.
    const waiting = (liveSessions.data ?? []).filter(
      (s) => s.customerPresent && !s.workerPresent,
    );
    if (waiting.length > 0) {
      setShow(true);
    } else {
      setShow(false);
      setUiNavState((ex) => ({ ...ex, incomingVideoChatPollNow: false }));
    }
  }, [liveSessions?.data]);

  if (!show) {
    return null;
  }

  return (
    <a
      className={"text-2xl animate-pulse-ring2 cursor-pointer"}
      onClick={() => {
        navigate("/admin/communication/support");
      }}
    >
      <PiVideoCamera />
    </a>
  );
}
